/** @format */

import React, { useState } from "react";

interface ReferenceImageProps {
   imageUrl: string;
   selectedImageStyle: any;
   isSelected: boolean;
}

const ReferenceImage = ({ imageUrl, selectedImageStyle, isSelected }: ReferenceImageProps) => {
   const [isLoaded, setIsLoaded] = useState(false);

   return (
      <div
         onClick={() => selectedImageStyle(imageUrl)}
         className={`relative rounded-2xl overflow-hidden w-full 2xl:h-[12rem] lg:h-[9rem] md:h-[8rem] h-[10rem]`}>
         {isSelected ? (
            <span
               style={{ border: "3px solid #000000" }}
               className={`w-[1.5rem] h-[1.5rem] p-1 top-2 left-2 z-30 absolute bg-turquoise rounded-full`}></span>
         ) : (
            <span className={`w-[1.5rem] h-[1.5rem] p-1 top-2 left-2 z-30 absolute bg-black border-2 border-turquoise rounded-full`}></span>
         )}
         <img
            onLoad={() => setIsLoaded(true)}
            className={`transition-opacity duration-1000 ease-in-out ${isLoaded ? "opacity-100" : "opacity-0"} w-full h-full rounded-xl`}
            src={imageUrl}
            alt="Reference image"
         />
      </div>
   );
};

export default ReferenceImage;
